export const SkillsDesign = [
  "_Illustrator",
  "_Photoshop",
  "_After Effects",
  "_Premiere",
  "_Corel Draw",
  "_Canva",
  "_Corporate Identity",
  "_Logos",
];